import { addToast } from "../Toast";

export function toastSubscriptionApiError(error: unknown): void {
  const msg =
    error instanceof Error && error.message.trim()
      ? error.message
      : typeof error === "string" && error.trim()
        ? error
        : "Something went wrong. Try again.";
  addToast({ message: msg, color: "danger" });
}
